<template>
	<div id="Main">
		<van-popup v-model="startshow" position="bottom">
			<van-datetime-picker @cancel="hide" @confirm="confirm" v-model="startDate" type="date" :min-date="startmin" :max-date="startmax" />
		</van-popup>
		<van-popup v-model="endshow" position="bottom">
			<van-datetime-picker @cancel="hide" @confirm="confirm" v-model="endDate" type="date" :min-date="endmin" :max-date="endmax" />
		</van-popup>
		<div class="screenbox" v-if="type==2">
			<van-row type="flex" justify="space-between">
				<van-col class="screen" @click.stop="picker(1)">起始：<span>{{start}}</span></van-col>
				<van-col class="screenicon">
					<van-icon class="icon" :name="require('../../assets/images/service/details9.png')" />
				</van-col>
				<van-col class="screen" @click.stop="picker(2)">截止：<span>{{end}}</span></van-col>
			</van-row>
			<van-button type="info" class="submit" @click="getHistorydata">查询</van-button>
		</div>
		<div v-if="sharesdata.length>0">
			<div class="box" v-for="(item,index) in sharesdata" :key="index">
				<p class="name">{{item[9]}}</p>
				<van-row type="flex" justify="space-between" class="time">
					<van-col class="timebox">发生日期：{{item[0]}}</van-col>
					<van-col class="timebox">发生时间：{{item[1]}}</van-col>
				</van-row>
				<div class="content">
					<div class="item">
						<p class="title">
							<van-icon class="icon" :name="require('../../assets/images/service/details1.png')" />股权代码</p>
						<p class="data">{{item[8]}}</p>
					</div>
					<div class="item">
						<p class="title">
							<van-icon class="icon" :name="require('../../assets/images/service/details5.png')" />发生金额</p>
						<p class="data">{{item[6]}}</p>
					</div>
					<div class="item">
						<p class="title">
							<van-icon class="icon" :name="require('../../assets/images/service/details7.png')" />业务名称</p>
						<p class="data">{{(item[2]==30061||item[2]==30082||item[2]==30083||item[2]==30089) ?'股权转出':(item[2]==30062||item[2]==30088)?'股权转入':item[3]}}</p>
					</div>
					<div class="item">
						<p class="title">
							<van-icon class="icon" :name="require('../../assets/images/service/details8.png')" />发生数量</p>
						<p class="data">{{item[10]}}</p>
					</div>
				</div>
			</div>
		</div>
		<div v-if="type==1 && sharesdata.length==0">该账户没有当日业务流水记录！</div>
		<div v-if="type==2 && sharesdata.length==0 && isHistorydata!=''">该账户指定日期范围内没有业务流水记录！</div>
		<div v-if="type==3">正在更新...</div>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				id: '',
				type: 3,
				newtype:'',
				/*, 1今日 2历史 */
				startDate: new Date(),
				/* 当前时间 */
				startmin: new Date(),
				/* 最小时间 */
				startmax: new Date(),
				/* 最大时间 */
				endDate: new Date(),
				/* 当前时间 */
				endmin: new Date(),
				/* 最小时间 */
				endmax: new Date(),
				/* 最大时间 */
				startshow: false,
				endshow: false,
				start: '',
				end: '',
				sharesdata: '' ,/* 数据 */
				isHistorydata:false
			}
		},
		methods: {
			settime() {/* 时间范围选择处理 */
				let nowData = new Date()
				let month = nowData.getMonth() + 1;
				let strDate = nowData.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				this.start = (nowData.getFullYear() - 2) + '-' + month + '-' + strDate
				this.end = nowData.getFullYear() + '-' + month + '-' + strDate
				this.startDate = new Date(this.start.replace(/-/g, "/"))
				this.startmin = new Date(this.start.replace(/-/g, "/"))
				this.endmin = new Date(this.start.replace(/-/g, "/"))
			},
			picker(type) {/* 时间弹窗显示处理 */
				window.console.log(type)
				if (type == 1) { /* 起始 */
					this.startshow = true;
				} else { /* 结束 */
					this.endshow = true;
				}
			},
			hide() {/* 时间弹窗显示处理 */
				this.startshow = false;
				this.endshow = false;
			},
			confirm(e) {/* 时间选择确定 */
				window.console.log(e)
				let nowData = new Date(e)
				let month = nowData.getMonth() + 1;
				let strDate = nowData.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				if (this.startshow) { /* 起始 */
					this.start = nowData.getFullYear() + '-' + month + '-' + strDate
					this.endmin = new Date(this.start.replace(/-/g, "/"))
					this.startshow = false;
				} else { /* 结束 */
					this.end = nowData.getFullYear() + '-' + month + '-' + strDate
					this.startmax = new Date(this.end.replace(/-/g, "/"))
					this.endshow = false;
				}
			},
			getdata() {/* 今日明细获取 */
				let t=this;
				let params = '2914;' + this.id + ';;;;;;'
				axiosPost.getdata(params).then((res) => {
					if (res.data.filter && res.data.filter.msg) {
						this.$dialog.alert({
							title: '提示',
							message:res.data.filter.msg,
						}).then(() => {
							if (res.data.filter.code == 0) {
								share()
							}
						});
					}else{
						share()
					}
					function share(){
						let str = res.data.data
						if(res.data.code==200){
							let code = str.slice(0, str.indexOf(';'))
							if (code == 200) {
								str = str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3)
								t.sharesdata = str.split('\\n');
								t.sharesdata.forEach((val, index) => {
									t.sharesdata[index] = val.split(';');
									t.sharesdata[index][0] = t.sharesdata[index][0].substring(0, 4) + '-' + t.sharesdata[index][0].substring(
										4, 6) + '-' + t.sharesdata[index][0].substring(6, 8)
								});
							} else if (code == 400) {
								// t.$toast({duration:4000,message:'该账户没有当日业务流水记录'});
							} else {
								t.$toast({duration:4000,message:str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3) + '，请稍后再试！'});
							}
						}else{
							t.$toast({duration:4000,message:res.data.msg});
						}
						t.type=t.newtype
					}
				}).catch((res) => {
					window.console.log(res)
				})
			},
			getHistorydata() {/* 历史明细获取 */
				let t=this;
				let params = '2922;' + this.id + ';;;;' + this.start.replace(/-/g, "") + ';' + this.end.replace(/-/g, "") + ';'
				axiosPost.getdata(params).then((res) => {
					if (res.data.filter && res.data.filter.msg) {
						this.$dialog.alert({
							title: '提示',
							message:res.data.filter.msg,
						}).then(() => {
							if (res.data.filter.code == 0) {
								share()
							}
						});
					}else{
						share()
					}
					function share(){
						let str = res.data.data
						t.isHistorydata=true;
						if(res.data.code==200){
							let code = str.slice(0, str.indexOf(';'))
							if (code == 200) {
								str = str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3)
								t.sharesdata = str.split('\\n');
								t.sharesdata.forEach((val, index) => {
									t.sharesdata[index] = val.split(';');
									t.sharesdata[index][0] = t.sharesdata[index][0].substring(0, 4) + '-' + t.sharesdata[index][0].substring(
										4, 6) + '-' + t.sharesdata[index][0].substring(6, 8)
								});
								window.console.log(t.sharesdata)
							} else if (code == 400) {
								// t.$toast({duration:4000,message:'该账户指定日期范围内没有业务流水记录'});
							} else {
								t.$toast({duration:4000,message:str.slice(str.indexOf(';') + 1, str.indexOf('\r') - 3) + '，请稍后再试！'});
							}
						}else{
							t.$toast({duration:4000,message:res.data.msg});
						}
						t.type=t.newtype
					}
				}).catch((res) => {
					window.console.log(res)
				})
			}

		},
		mounted() {
			this.newtype = this.$route.query.type
			this.newtype == 2 ? this.settime() : ''
			this.id = this.$route.query.id
			if (this.newtype == 1) {
				this.getdata();
			} else {
				this.type = this.$route.query.type
				// this.getHistorydata();
			}
		},
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		min-height: 100vh;
		background-color: #f2f9ff;

		.screenbox {
			background-color: #fff;
			border-radius: 8px;
			padding: 1rem;
			margin-bottom: 2rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;

			.submit {
				width: 100%;
				background-color: #fa6b6b;
				border: 0;
				font-size: 1.6rem;
				border-radius: 8px;
				margin-top: 1rem;
			}

			.screen {
				font-size: 1.5rem;
				color: rgba(51, 51, 51, .4);

				span {
					color: #333;
				}
			}
		}

		.time {
			border-top: 1px solid #e0dfdf;
			padding: 0.8rem 0;

			.timebox {
				border-radius: 100rem;
				background-color: rgba(250, 107, 107, .1);
				font-size: 1.2rem;
				padding: 0 0.6rem;
				line-height: 2rem;
				color: #8c8b8b;
			}
		}

		.box {
			background-color: #fff;
			border-radius: 8px;
			padding: 0 1rem;
			margin-bottom: 2rem;
			box-shadow: 0 2px 5px 1px #e4ebfa;

			.name {
				text-align: left;
				font-size: 1.8rem;
				color: #333;
				line-height: 3.5rem;
				padding-top: 0.6rem;
				font-weight: bold;
			}

			.content {
				display: flex;
				flex-wrap: wrap;

				.item {
					width: 50%;
					padding: 1rem 0;
					border-top: 1px solid #e0dfdf;
					font-size: 0;
					line-height: 2rem;

					&:nth-child(2n) {
						border-left: 1px solid #e0dfdf;
					}

					.title {
						font-size: 1.5rem;
						color: #8c8b8b;

						.icon {
							margin-right: 0.5rem;
							vertical-align: middle;
						}
					}

					.data {
						color: #333333;
						font-size: 1.6rem;
					}
				}
			}
		}
	}
</style>
